<h4 class="section-heading">
    <span>Unit Preferences</span>
    <div></div>
</h4>
<div *ngIf="organisation && organisationSettingsForm">
    <form [formGroup]="organisationSettingsForm">
        <div class="data horizontal-container vertical-align">
            <span class="display-label">Dates</span>
            <div class="fcol-3">
                <editable
                    *ngIf="canEdit"
                    [confirmationButtons]="true"
                    (update)="updateUnitsPreferences()"
                    [disabled]="working"
                    (clickCancel)="revertSettingsChange('dateFormat')"
                >
                    <ng-template viewMode>
                        {{ formattedDateLabel }}
                    </ng-template>
                    <ng-template editMode let-context="context">
                        <ng-select
                            [items]="dateFormatOptions"
                            bindLabel="name"
                            bindValue="value"
                            formControlName="dateFormat"
                            [clearable]="false"
                        ></ng-select>
                    </ng-template>
                </editable>
            </div>
            <div *ngIf="!canEdit">
                {{ formattedDateLabel }}
            </div>
            <span class="help-block"> e.g. {{ formattedDateExample }} </span>
        </div>

        <div class="data horizontal-container vertical-align">
            <span class="display-label">Time</span>
            <div class="fcol-3">
                <editable
                    *ngIf="canEdit"
                    [confirmationButtons]="true"
                    (update)="updateUnitsPreferences()"
                    (clickCancel)="revertSettingsChange('timeFormat')"
                    [disabled]="working"
                >
                    <ng-template viewMode>
                        {{ formattedTimeLabel }}
                    </ng-template>
                    <ng-template editMode let-context="context">
                        <ng-select
                            [items]="timeFormatOptions"
                            bindLabel="name"
                            bindValue="value"
                            formControlName="timeFormat"
                            [clearable]="false"
                        ></ng-select>
                    </ng-template>
                </editable>
            </div>
            <div *ngIf="!canEdit">
                {{ formattedTimeLabel }}
            </div>
            <span class="help-block">
                e.g.
                {{ formattedTimeExample }}
            </span>
        </div>

        <!-- <div class="data horizontal-container vertical-align">
            <span class="display-label">Height</span>
            <div class="fcol-3">
                <editable
                    *ngIf="canEdit"
                    [confirmationButtons]="true"
                    (update)="updateUnitsPreferences()"
                    (clickCancel)="revertSettingsChange('heightUnit')"
                    [disabled]="working"
                >
                    <ng-template viewMode>
                        {{ formattedHeightLabel }}
                    </ng-template>
                    <ng-template editMode let-context="context">
                        <ng-select
                            [items]="heightFormatOptions"
                            bindLabel="name"
                            bindValue="value"
                            formControlName="heightUnit"
                            [clearable]="false"
                        ></ng-select>
                    </ng-template>
                </editable>
            </div>
            <div *ngIf="!canEdit">
                {{ formattedHeightLabel }}
            </div>
            <span class="help-block">
                e.g.
                {{ formattedHeightExample }}
            </span>
        </div>

        <div class="data horizontal-container vertical-align">
            <span class="display-label">Distance</span>
            <div class="fcol-3">
                <editable
                    *ngIf="canEdit"
                    [confirmationButtons]="true"
                    (update)="updateUnitsPreferences()"
                    (clickCancel)="revertSettingsChange('distanceUnit')"
                    [disabled]="working"
                >
                    <ng-template viewMode>
                        {{ formattedDistanceLabel }}
                    </ng-template>
                    <ng-template editMode let-context="context">
                        <ng-select
                            [items]="distanceFormatOptions"
                            bindLabel="name"
                            bindValue="value"
                            formControlName="distanceUnit"
                            [clearable]="false"
                        ></ng-select>
                    </ng-template>
                </editable>
            </div>
            <div *ngIf="!canEdit">
                {{ formattedDistanceLabel }}
            </div>
            <span class="help-block">
                e.g.
                {{ formattedDistanceExample }}
            </span>
        </div>

        <div class="data horizontal-container vertical-align">
            <span class="display-label">Speed</span>
            <div class="fcol-3">
                <editable
                    *ngIf="canEdit"
                    [confirmationButtons]="true"
                    (update)="updateUnitsPreferences()"
                    (clickCancel)="revertSettingsChange('speedUnit')"
                    [disabled]="working"
                >
                    <ng-template viewMode>
                        {{ formattedSpeedLabel }}
                    </ng-template>
                    <ng-template editMode let-context="context">
                        <ng-select
                            [items]="speedFormatOptions"
                            bindLabel="name"
                            bindValue="value"
                            formControlName="speedUnit"
                            [clearable]="false"
                        ></ng-select>
                    </ng-template>
                </editable>
            </div>
            <div *ngIf="!canEdit">
                {{ formattedSpeedLabel }}
            </div>
            <span class="help-block">
                e.g.
                {{ formattedSpeedExample }}
            </span>
        </div>

        <div class="data horizontal-container vertical-align">
            <span class="display-label">Weight</span>
            <div class="fcol-3">
                <editable
                    *ngIf="canEdit"
                    [confirmationButtons]="true"
                    (update)="updateUnitsPreferences()"
                    (clickCancel)="revertSettingsChange('weightUnit')"
                    [disabled]="working"
                >
                    <ng-template viewMode>
                        {{ formattedWeightLabel }}
                    </ng-template>
                    <ng-template editMode let-context="context">
                        <ng-select
                            [items]="weightFormatOptions"
                            bindLabel="name"
                            bindValue="value"
                            formControlName="weightUnit"
                            [clearable]="false"
                        ></ng-select>
                    </ng-template>
                </editable>
            </div>
            <div *ngIf="!canEdit">
                {{ formattedWeightLabel }}
            </div>
            <span class="help-block">
                e.g.
                {{ formattedWeightExample }}
            </span>
        </div>

        <div class="data horizontal-container vertical-align">
            <span class="display-label">Temperature</span>
            <div class="fcol-3">
                <editable
                    *ngIf="canEdit"
                    [confirmationButtons]="true"
                    (update)="updateUnitsPreferences()"
                    (clickCancel)="revertSettingsChange('temperatureUnit')"
                    [disabled]="working"
                >
                    <ng-template viewMode>
                        {{ formattedTemperatureLabel }}
                    </ng-template>
                    <ng-template editMode let-context="context">
                        <ng-select
                            [items]="temperatureFormatOptions"
                            bindLabel="name"
                            bindValue="value"
                            formControlName="temperatureUnit"
                            [clearable]="false"
                        ></ng-select>
                    </ng-template>
                </editable>
            </div>
            <div *ngIf="!canEdit">
                {{ formattedTemperatureLabel }}
            </div>
            <span class="help-block">
                e.g.
                {{ formattedTemperatureExample }}
            </span>
        </div> -->
    </form>
</div>
